import { useRef, useState } from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import { useHref, useNavigate } from "react-router-dom";
import useIsMobile from "../../../hooks/useIsMobile";
import PermintaanMinyakDelete from "./permintaan-minyak-delete";
import PermintaanMinyakList from "./permintaan-minyak-list";

const editorPath = "/transaksi/permintaan-minyak/edit";

const PermintaanMinyakMain = (props, { className }) => {
  const listRef = useRef(null);
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  // the url with the base name of the app, for the new tab
  const editorHref = useHref(editorPath);

  const [visibleDeleteDialog, setVisibleDeleteDialog] = useState(false);
  const [editorData, setEditorData] = useState(null);

  // handle ui event section

  // the form opens in a new tab (same tab on mobile); refresh the list when coming back
  const openEditor = (id) => {
    if (isMobile) navigate(`${editorPath}/${id}`);
    else window.open(`${editorHref}/${id}`, "_blank");
  };

  const handleOnClickRowEdit = (row) => {
    openEditor(row.id);
  };

  const handleOnClickAddNew = () => {
    openEditor("new");
  };

  const handleOnClickRowDelete = (row) => {
    if (row.id && row.id > 0) {
      setEditorData(row);
      setVisibleDeleteDialog(true);
    }
  };

  const handleOnConfirmedDelete = (data) => {
    listRef.current.handleOnDeleteViewRow(data);
    setVisibleDeleteDialog(false);
  };

  return (
    <div className={`col-start-start p-4 gap-4 w-100`}>
      <ConfirmDialog />

      <PermintaanMinyakDelete
        visible={visibleDeleteDialog}
        onHide={() => setVisibleDeleteDialog(false)}
        editorData={editorData}
        onConfirmed={handleOnConfirmedDelete}
      />

      <PermintaanMinyakList
        ref={listRef}
        onClickRowEdit={handleOnClickRowEdit}
        onClickRowDelete={handleOnClickRowDelete}
        onClickAddNew={handleOnClickAddNew}
      />
    </div>
  );
};

export default PermintaanMinyakMain;
